import React from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import InvoicesWrapper from "./InvoicesWrapper";
import ProtectedRoute from "../../../../components/util-components/ProtectedRoute";

const PARENT_URL = "/cms/finance/invoices";

// Wrapper component to extract companyType parameter
const InvoicesWrapperWithParams = () => {
  const { companyType } = useParams();
  return (
    <ProtectedRoute routeKey={`shop-invoices-${companyType}`}>
      <InvoicesWrapper />
    </ProtectedRoute>
  );
};

const Invoices = () => {
  return (
    <Routes>
      <Route path="/:companyType" element={<InvoicesWrapperWithParams />} />
      <Route path="" element={<Navigate to={`${PARENT_URL}/chefs-farm`} replace />} />
    </Routes>
  );
};

export default Invoices;
